export default __webpack_public_path__ + "static/media/dtsu5168_ct_shunt_trip.0aeab93f.jpg";